import { adminLayoutWrap } from '@middlewares';
import StandingAccessReportsPage from '@StandingAccess/pages/StandingAccessReportsPage';
import { Flag } from '@utils';
import { Permission } from '@common/utils/admin_permissions';
import CreateStandingAccessReportPage from './pages/CreateStandingAccessReportPage';
import StandingAccessReportAccessFlowPage from './pages/StandingAccessReportAccessFlowPage';
import ViewStandingAccessReportPage from './pages/StandingAccessReportPage';
import StandingAccessReportRevokePage from './pages/StandingAccessReportRevokePage';

export const routes = {
  StandingAccessReports: {
    label: 'JIT Protect',
    path: '/jit-report',
    page: adminLayoutWrap({
      children: <StandingAccessReportsPage />,
      flag: Flag.ASSESSMENT_REPORTS,
      permissions: [Permission.JIT_PROTECT_READ],
    }),
  },
  ViewStandingAccessReport: {
    label: 'View JIT Protect Assessment',
    path: '/jit-report/view/:id',
    page: adminLayoutWrap({
      children: <ViewStandingAccessReportPage />,
      flag: Flag.ASSESSMENT_REPORTS,
      permissions: [Permission.JIT_PROTECT_READ],
    }),
  },
  StandingAccessReportAccessFlow: {
    label: 'Create Access Flow',
    path: '/jit-report/view/:id/create-access-flow',
    page: adminLayoutWrap({
      children: <StandingAccessReportAccessFlowPage />,
      flag: Flag.ASSESSMENT_REPORTS,
      permissions: [Permission.JIT_PROTECT_WRITE],
    }),
  },
  StandingAccessReportRevoke: {
    label: 'Revoke Access',
    path: '/jit-report/view/:id/revoke-access',
    page: adminLayoutWrap({
      children: <StandingAccessReportRevokePage />,
      flag: Flag.ASSESSMENT_REPORTS,
      permissions: [Permission.JIT_PROTECT_WRITE],
    }),
  },
  CreateStandingAccessReport: {
    label: 'Create JIT Protect Assessment',
    path: '/jit-report/new',
    page: adminLayoutWrap({
      children: <CreateStandingAccessReportPage />,
      flag: Flag.ASSESSMENT_REPORTS,
      permissions: [Permission.JIT_PROTECT_WRITE],
    }),
  },
};
